import { CalendarClock, ExternalLink, MessageCircle } from "lucide-react";

const DISCORD_URL = "https://discord.gg/F6pQWdZnWA";

export default function LiveClass() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8" data-testid="live-class-page">
      <section className="live-class-hero" data-testid="live-class-hero-section">
        <p className="section-kicker" data-testid="live-class-kicker">aula ao vivo</p>
        <h1 className="mt-4 font-display text-4xl font-black sm:text-5xl lg:text-6xl" data-testid="live-class-heading">Conversação comigo todo domingo.</h1>
        <p className="mt-5 max-w-3xl text-base font-bold text-white/75 md:text-lg" data-testid="live-class-description">Entre na comunidade para participar das aulas de conversação ao vivo por 1 hora, todo domingo às 13:00 no horário de Brasília.</p>
        <div className="mt-8 grid gap-4 md:grid-cols-2" data-testid="live-class-info-grid">
          <div className="neo-card surface-neutral p-5" data-testid="live-class-schedule-card">
            <CalendarClock size={28} />
            <h2 className="mt-4 font-display text-3xl font-black" data-testid="live-class-schedule-title">Domingo · 13:00 BRT</h2>
            <p className="mt-2 text-sm font-bold text-white/70" data-testid="live-class-schedule-copy">Uma hora focada em destravar fala real, perguntas rápidas e confiança em conversas.</p>
          </div>
          <div className="neo-card surface-blue p-5" data-testid="live-class-discord-card">
            <MessageCircle size={28} />
            <h2 className="mt-4 font-display text-3xl font-black" data-testid="live-class-discord-title">Comunidade no Discord</h2>
            <p className="mt-2 text-sm font-bold text-white/70" data-testid="live-class-discord-copy">Use o botão abaixo para entrar e receber a direção da aula.</p>
            <a className="primary-action mt-5 w-auto" href={DISCORD_URL} target="_blank" rel="noreferrer" data-testid="live-class-discord-link">
              Entrar no Discord <ExternalLink size={18} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}